import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useClasses } from '../../../utils/overrides';
import { createUseStyles } from '../../../utils/styles';
import styles from './styles';
const useStyles = createUseStyles(styles, 'Loader');
function Loader(_ref) {
  let {
    classes: classesProp,
    className,
    size = 'medium',
    color = 'primary'
  } = _ref;
  const classes = useClasses(useStyles, classesProp);
  const rootClassName = classnames(className, classes.root, [classes[color]], [classes[size]]);
  return /*#__PURE__*/React.createElement("div", {
    className: rootClassName
  });
}
process.env.NODE_ENV !== "production" ? Loader.propTypes = {
  /** Custom CSS class for styling the loader container */
  className: PropTypes.string,
  /**
   * Size of the loader.
   * Available options from smallest to largest:
   * 'mini', 'tiny', 'small', 'medium', 'large', 'big', 'huge', 'massive'
   */
  size: PropTypes.oneOf(['mini', 'tiny', 'small', 'medium', 'large', 'big', 'huge', 'massive']),
  /**
   * Color variant for the loader.
   * - 'primary': Blue based on actionMajor color (default)
   * - 'actionMinor': Purple based on actionMinor color
   * - 'danger': Red based on negative/error colors
   * - 'white': White color for use on dark backgrounds
   */
  color: PropTypes.oneOf(['primary', 'actionMinor', 'danger', 'white'])
} : void 0;
export default /*#__PURE__*/React.memo(Loader);